import axios from '../helpers/bearerAxios';
import { logger } from './loggingService';


const getSetbackPathway = (oppId: string) => {
    return axios.get(`${import.meta.env.VITE_BASE_URL}${import.meta.env.VITE_SETBACK_PATHWAY_API_URL}?OpportunityId=${oppId}`)
        .then(response => {
            return response;
        })
        .catch(error => {
            logger.error(error);
            return error;
        })
}

const setbackPathwayService = {
    getSetbackPathway
}

export default setbackPathwayService;
